//@ts-nocheck
import React, { useCallback, useMemo, useRef, useState } from "react";
import isHotkey from "is-hotkey";
import styled from "styled-components";
import { Editable, withReact, useSlate, Slate } from "slate-react";
import {
  Editor,
  Transforms,
  createEditor,
  Element as SlateElement,
} from "slate";
import { withHistory } from "slate-history";

import { Icon, Typography } from "../../../../../../typo-components";
import { Styles } from "../../../../../../config";

import { SlateButton, SlateTable, SlateTextButton } from "./_elements";
import { Popover, Popovers } from "../../../../../../element-components";
import { Flex } from "../../../../../../container-components";
import Form from "../../../..";
const Point = null;

const Button = styled.button`
  width: 40px;
  height: 40px;
  border-radius: 5px;
  cursor: pointer;
  background: ${(props) =>
    Styles.Color[props.active ? "tertiary" : "white"]}!important;

  & > i {
    color: ${(props) =>
    Styles.Color[props.active ? "white" : "tertiary"]}!important;
  }

  // margin: 0 10px 0 0;
`;

const Toolbar = styled.div`
  display: flex;
  justify-content: space-evenly;
  padding: 10px 0 30px 0;
`;

const HOTKEYS = {
  "mod+b": "bold",
  "mod+i": "italic",
  "mod+u": "underline",
  "mod+`": "code",
};

const LIST_TYPES = ["numbered-list", "bulleted-list"];

const RichTextExample = (props) => {
  const { name } = props;

  const [value, setValue] = useState(props.value);
  const renderElement = useCallback(
    (props) => <Element {...props} />,
    [props.value]
  );
  const renderLeaf = useCallback((props) => <Leaf {...props} />, [props.value]);
  const editorRef = useRef();

  if (!editorRef.current)
    editorRef.current = withTables(withHistory(withReact(createEditor())));

  const editor = editorRef.current;

  return (
    <div style={{ minHeight: "300px" }}>
      <Slate
        {...props}
        editor={editor}
        value={value}
        onChange={(value) => {
          props.onChange({ target: { name, value } }, name, value);
          setValue(value);
        }}
      >
        <Toolbar>
          <MarkButton format="bold" icon="format_bold" />
          <MarkButton format="italic" icon="format_italic" />
          <MarkButton format="underline" icon="format_underlined" />
          <MarkButton format="code" icon="code" />
          <BlockButton format="heading-one" icon="looks_one" />
          <BlockButton format="heading-two" icon="looks_two" />
          <BlockButton format="block-quote" icon="format_quote" />
          <BlockButton format="numbered-list" icon="format_list_numbered" />
          <BlockButton format="bulleted-list" icon="format_list_bulleted" />
          {/* <TableButton format="table" icon="table" action="insert" />
        <TableButton format="table" icon="table" action="increase" /> */}
          <ButtonButton format="button" icon="add_comment" action="insert" />
          <ButtonButton
            format="text-button"
            icon="insert_link"
            action="insert"
          />
        </Toolbar>
        <Editable
          id="slate-editor"
          style={{ width: "100%" }}
          renderElement={renderElement}
          renderLeaf={renderLeaf}
          placeholder="Enter some rich text…"
          spellCheck
          autoFocus
          onKeyDown={(event) => {
            for (const hotkey in HOTKEYS) {
              if (isHotkey(hotkey, event)) {
                event.preventDefault();
                const mark = HOTKEYS[hotkey];
                toggleMark(editor, mark);
              }
            }
          }}
        />
      </Slate>
    </div>
  );
};

const withTables = (editor) => {
  const { deleteBackward, deleteForward, insertBreak } = editor;

  editor.deleteBackward = (unit) => {
    const { selection } = editor;

    if (selection && Range.isCollapsed && Range?.isCollapsed(selection)) {
      const [cell] = Editor.nodes(editor, {
        match: (n) =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === "table-cell",
      });

      if (cell) {
        const [, cellPath] = cell;
        const start = Editor.start(editor, cellPath);

        if (Point.equals(selection.anchor, start)) {
          return;
        }
      }
    }

    deleteBackward(unit);
  };

  editor.deleteForward = (unit) => {
    const { selection } = editor;

    if (selection && Range.isCollapsed && Range.isCollapsed(selection)) {
      const [cell] = Editor.nodes(editor, {
        match: (n) =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === "table-cell",
      });

      if (cell) {
        const [, cellPath] = cell;
        const end = Editor.end(editor, cellPath);

        if (Point.equals(selection.anchor, end)) {
          return;
        }
      }
    }

    deleteForward(unit);
  };

  editor.insertBreak = () => {
    const { selection } = editor;

    if (selection) {
      const [table] = Editor.nodes(editor, {
        match: (n) =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === "table",
      });
    }

    insertBreak();
  };

  return editor;
};

const manageButtonNode = ({
  action,
  editor,
  data,
  format,
}) => {
  if (action === "insert") {
    editor.insertNode({
      type: format,
      children: [{ text: data.text }],
      link: data.link,
      background: data.color,
    });
    editor.insertNode({
      children: [{ text: "" }],
    });
  }
};

const manageTableNode = ({
  action,
  editor,
}) => {
  if (action === "insert") {
    const { selection } = editor;

    let at = [editor.children?.length || 0];

    if (selection?.focus?.path) {
      at = [selection.focus.path[0] + 1];
    }
    Transforms.insertNodes(
      editor,
      [
        {
          type: "table",
          children: [
            {
              type: "table-row",
              children: [
                {
                  type: "table-cell",
                  children: [{ type: "paragraph", children: [{ text: "Hi" }] }],
                },
              ],
            },
          ],
        },
      ],
      { at }
    );
  } else if (action === "increase") {
    const { selection } = editor;

    if (selection) {
      const [currentRow] = Editor.nodes(editor, {
        match: (n) =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === "table-cell",
      });

      if (currentRow) {
        const [currentRowData, currentRowLocation] = currentRow;

        Transforms.insertNodes(
          editor,
          [
            {
              type: "table-cell",
              children: [{ type: "paragraph", children: [{ text: "Hi" }] }],
            },
          ],
          { at: currentRowLocation }
        );
      }
    }
  }
};

const toggleBlock = (editor, format) => {
  const isActive = isBlockActive(editor, format);
  const isList = LIST_TYPES.includes(format);

  Transforms.unwrapNodes(editor, {
    match: (n) =>
      LIST_TYPES.includes(
        !Editor.isEditor(n) && SlateElement.isElement(n) && n.type
      ),
    split: true,
  });
  const newProperties = {
    type: isActive ? "paragraph" : isList ? "list-item" : format,
  };
  Transforms.setNodes(editor, newProperties);

  if (!isActive && isList) {
    const block = { type: format, children: [] };
    Transforms.wrapNodes(editor, block);
  }
};

const toggleMark = (editor, format) => {
  const isActive = isMarkActive(editor, format);

  if (isActive) {
    Editor.removeMark(editor, format);
  } else {
    Editor.addMark(editor, format, true);
  }
};

const isBlockActive = (editor, format) => {
  const [match] = Editor.nodes(editor, {
    match: (n) =>
      !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
  });

  return !!match;
};

const isMarkActive = (editor, format) => {
  const marks = Editor.marks(editor);
  return marks ? marks[format] === true : false;
};

const Element = ({ attributes, children, element }) => {
  switch (element.type) {
    case "section":
      return <div {...attributes}>{children}</div>;
    case "text-button":
      return (
        <SlateTextButton
          color={element.background}
          link={element.link}
          {...attributes}
        >
          {children}
        </SlateTextButton>
      );
    case "button":
      return (
        <SlateButton
          background={element.background}
          link={element.link}
          {...attributes}
        >
          {children}
        </SlateButton>
      );
    case "table":
      return <SlateTable {...attributes}>{children}</SlateTable>;
    case "tbody":
      return <tbody {...attributes}>{children}</tbody>;
    case "table-row":
      return <tr {...attributes}>{children}</tr>;
    case "table-cell":
      return <td {...attributes}>{children}</td>;
    case "block-quote":
      return <blockquote {...attributes}>{children}</blockquote>;
    case "bulleted-list":
      return <ul {...attributes}>{children}</ul>;
    case "heading-one":
      return <h1 {...attributes}>{children}</h1>;
    case "heading-two":
      return <h2 {...attributes}>{children}</h2>;
    case "list-item":
      return <li {...attributes}>{children}</li>;
    case "numbered-list":
      return <ol {...attributes}>{children}</ol>;
    default:
      return (
        <span {...attributes} style={{ whiteSpace: "break-spaces" }}>
          {children}
        </span>
      );
  }
};

const Leaf = ({ attributes, children, leaf }) => {
  if (leaf.bold) {
    children = <strong>{children}</strong>;
  }

  if (leaf.code) {
    children = <code>{children}</code>;
  }

  if (leaf.italic) {
    children = <em>{children}</em>;
  }

  if (leaf.underline) {
    children = <u>{children}</u>;
  }

  return <span {...attributes}>{children}</span>;
};

const InsertButtonForm = ({ editor, action, format }) => {
  return (
    <Form
      buttonConfig={{ text: "Create", label: "edit" }}
      helperText={(values) => {
        const helperText = {
          link: "Paste the relative link you want to use. Ex. verify?token={token}",
          text: "Paste the text you want to use.",
          color:
            "Paste the Hexcode or RGB of the color you would like to use Ex. #ffffff or rgb(123,123,123)",
        };
        return helperText;
      }}
      onSubmit={async (values) => {
        const { link, text, color } = values;

        editor.insertBreak();

        manageButtonNode({
          action,
          editor,
          format,
          data: { link, text, color },
        });
      }}
      Inputs={[
        {
          label: "Link",
          name: "link",
        },
        {
          label: "Text",
          name: "text",
        },
        {
          label: "Color",
          name: "color",
        },
        {
          input: "custom",
          Cell: () => {
            return (
              <Flex>
                {Object.entries(Styles.Color).map(
                  ([key, value]) => {
                    return (
                      <Flex width="auto" nowrap>
                        {" "}
                        <Typography margin="0 10px" color={key} variant="t7">
                          {value.light}
                        </Typography>
                      </Flex>
                    );
                  }
                )}
              </Flex>
            );
          },
        },
      ]}
      initialValues={{ text: "", link: "" }}
    ></Form>
  );
};

const ButtonButton = ({ format, icon, action }) => {
  const editor = useSlate();
  return (
    <Popovers.Icon
      type="button"
      color="tertiary"
      iconConfig={{ name: icon }}
      popoverConfig={{
        jsx: (
          <InsertButtonForm editor={editor} format={format} action={action} />
        ),
        isClick: true,
      }}
      active={isBlockActive(editor, format)}
    ></Popovers.Icon>
  );
};

const TableButton = ({ format, icon, action }) => {
  const editor = useSlate();
  return (
    <Button
      type="button"
      active={isBlockActive(editor, format)}
      onMouseDown={(event) => {
        event.preventDefault();
        manageTableNode({ action, editor });
      }}
    >
      <Icon size="small" color="white" name={icon}></Icon>
    </Button>
  );
};

const BlockButton = ({ format, icon }) => {
  const editor = useSlate();

  return (
    <Button
      type="button"
      active={isBlockActive(editor, format)}
      onMouseDown={(event) => {
        event.preventDefault();
        toggleBlock(editor, format);
      }}
    >
      <Icon size="small" name={icon}></Icon>
    </Button>
  );
};

const MarkButton = ({ format, icon }) => {
  const editor = useSlate();

  return (
    <Button
      type="button"
      active={isMarkActive(editor, format)}
      onMouseDown={(event) => {
        event.preventDefault();
        toggleMark(editor, format);
      }}
    >
      <Icon size="small" name={icon}></Icon>
    </Button>
  );
};

export default RichTextExample;
